import _defineProperty from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useEffect, useState } from 'react';
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import { Popover } from '@mui/material';
import clsx from 'clsx';
import { useLocaleStore } from '../../store/LocaleStore';
import { getCountryNormalLogoUrl } from '../../utils/country';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var LocaleSwitch = function LocaleSwitch(props) {
  var className = props.className,
      valueChange = props.valueChange,
      _props$supportCountri = props.supportCountries,
      supportCountries = _props$supportCountri === void 0 ? [] : _props$supportCountri,
      value = props.value,
      _props$arrowClassName = props.arrowClassName,
      arrowClassName = _props$arrowClassName === void 0 ? 'text-white' : _props$arrowClassName,
      popoverAnchorOrigin = props.popoverAnchorOrigin,
      containerClassName = props.containerClassName;

  var _useState = useState(undefined),
      popoverId = _useState[0],
      setPopoverId = _useState[1];

  var _useState2 = useState(null),
      anchorEl = _useState2[0],
      setAnchorEl = _useState2[1];

  var _useState3 = useState(value),
      currentLocaleCountry = _useState3[0],
      setCurrentLocaleCountry = _useState3[1];

  var _useState4 = useState(supportCountries),
      countries = _useState4[0],
      setCountries = _useState4[1];

  var _useLocaleStore = useLocaleStore(),
      updateLocale = _useLocaleStore.actions.updateLocale;
  /**
   * effects
   */


  useEffect(function () {
    if (value) {
      setCurrentLocaleCountry(value);
      updateLocale(value);
    }
  }, [value]);
  /**
   * methods
   */

  var changeLocaleAction = function changeLocaleAction(e) {
    setPopoverId('common-locale-popover');
    setAnchorEl(e.currentTarget);
  };

  var closeLocaleAction = function closeLocaleAction() {
    setAnchorEl(null);
    setPopoverId(undefined);
  };

  var selectLocaleAction = function selectLocaleAction(item) {
    valueChange === null || valueChange === void 0 ? void 0 : valueChange(item.value);
    closeLocaleAction();
  };

  var open = Boolean(anchorEl);
  return /*#__PURE__*/_jsxs("div", {
    className: clsx('flex flex-col items-center justify-end', className),
    children: [/*#__PURE__*/_jsxs("div", {
      className: clsx('flex cursor-pointer flex-row items-center space-x-1 rounded-full border-2 px-3 py-1 transition-all duration-300 ease-out hover:border-stone-600', {
        'border-stone-600 bg-gray-100': open
      }, containerClassName),
      onClick: changeLocaleAction,
      children: [/*#__PURE__*/_jsx("img", {
        width: "30",
        src: getCountryNormalLogoUrl(currentLocaleCountry),
        alt: currentLocaleCountry
      }), open ? /*#__PURE__*/_jsx(ExpandLess, {
        className: clsx('w-5', {
          '!text-black': open
        }, arrowClassName)
      }) : /*#__PURE__*/_jsx(ExpandMore, {
        className: clsx('w-5', {
          '!text-stone-600': open
        }, arrowClassName)
      })]
    }), /*#__PURE__*/_jsx(Popover, {
      id: popoverId,
      open: Boolean(anchorEl),
      anchorEl: anchorEl,
      onClose: closeLocaleAction,
      anchorOrigin: _objectSpread({
        vertical: 'bottom',
        horizontal: -130
      }, popoverAnchorOrigin),
      children: /*#__PURE__*/_jsx("div", {
        className: "flex max-h-[400px] flex-col p-2",
        children: countries.map(function (item) {
          var isSelected = currentLocaleCountry === item.value;
          return /*#__PURE__*/_jsxs("div", {
            className: clsx('flex cursor-pointer flex-row items-center space-x-1 rounded-sm p-2 hover:bg-slate-100', {
              'bg-slate-100': isSelected
            }),
            onClick: function onClick() {
              return selectLocaleAction(item);
            },
            children: [/*#__PURE__*/_jsxs("div", {
              className: "flex flex-1 flex-row items-center space-x-1",
              children: [/*#__PURE__*/_jsx("img", {
                width: "30",
                src: getCountryNormalLogoUrl(item.value),
                alt: item.value
              }), /*#__PURE__*/_jsx("span", {
                className: "font-medium",
                children: item.label
              })]
            }), isSelected && /*#__PURE__*/_jsx(CheckRoundedIcon, {
              className: "w-4"
            })]
          }, item.value);
        })
      })
    })]
  });
};